import React, { useRef, useState, Fragment } from "react";
import { NavLink } from "react-router-dom";
import { scrollIntoView } from "seamless-scroll-polyfill";
import AddToCartForm from "./AddToCartForm";
import Button from "../../components/Button";
import Carousel from "../../components/UpdatedCarousel";
import Bands from "./Bands";
import ArrowRightIcon from "@heroicons/react/24/outline/ArrowRightIcon";
import ArrowLeftIcon from "@heroicons/react/24/outline/ArrowLeftIcon";
import VideoModal from "../../components/VideoModal";
import { Transition, Dialog } from "@headlessui/react";

import { isProb3 } from "../../utils/siteOrigin";
const SwiperImages = [
  "bands1.png",
  "bands2.png",
  "bands3.png",
  "bands4.png",
  "bands5.png",
  "bands6.png",
  "bands7.png",
];

export default function Page() {
  const nextPage = isProb3() ? "/check-out" : "/nutrition-products";
  const nextButtonRef = useRef(null);
  const scrollToElement = () => {
    if (nextButtonRef.current) {
      scrollIntoView(nextButtonRef.current, {
        behavior: "smooth",
        block: "start",
        inline: "nearest",
      });
    }
  };
  const [isOpenVideo, setIsOpenVideo] = useState(false);
  const [paypalModalOpen, setPaypalModalOpen] = useState(false);

  return (
    <>
      <section className="container mx-auto flex-1 p-5 flex flex-col lg:max-w-full relative">
        <div className="grid-cols-1 flex flex-col-reverse lg:grid lg:grid-cols-2 lg:flex-row flex-1 gap-14">
          <div className="relative flex flex-col  mt-5 md:mt-5 bg-[#302b2b] p-6 rounded-[1rem]">
            <h1 className="pb-4 md:pb-0 md:text-7xl text-5xl roboto-medium">
              <span className="text-white">B</span>
              <span className="text-[#00adef] mr-3">3</span>
              <span className="text-white">Bands</span>
            </h1>
            <img
              alt="30Day Icon"
              src="./assets/images/30days-free.png"
              className="w-[80px] h-[80px] md:w-[130px] md:h-[130px] absolute top-[-30px] right-[-20px] md:top-[-35px] md:right-[-45px]"
            />
            <Bands />
            <div className="">
              <AddToCartForm onClose={scrollToElement} />
            </div>
          </div>
          <div className="block my-auto mb-6 md:mb-auto items-center">
            <Carousel swiperImages={SwiperImages} />

            <div className="mt-16">
              <VideoModal
                open={isOpenVideo}
                setOpen={setIsOpenVideo}
                videoId="1045362105"
              />
            </div>
          </div>
        </div>
        {/* <div className="flex text-center md:justify-center relative items-center flex-col sm:flex-row justify-between">
        <div className="w-full flex items-center justify-center md:justify-start relative mr-2 pt-4">
          <div className="flex flex-col ">
            <img
              alt="paypal credit"
              src="./assets/images/paypal-credit.png"
              className="w-[100px] md:w-[120px]"
            />
            <span className="text-[10px] font-semibold">
              $0 DOWN 0% INTEREST FOR 6 MONTHS
            </span>
          </div>
          <img
            alt="money-guarantee"
            src="./assets/images/guarantee.jpg"
            className="w-[70px] md:w-[90px] top-6 right-5 md:top-2 ml-2 md:right-2"
          />
        </div>
      </div> */}
        <div class=" roboto-medium mt-4 flex items-center justify-between bg-[#00ADEF] rounded-full px-8 py-2 w-full">
          <span className="text-white text-md md:text-3xl font-semibold">
            As low as <span className="font-bold">$2.99</span>/per day with
            <button
              onClick={() => setPaypalModalOpen(true)}
              className="underline font-bold ml-2"
            >
              PayPal Credit
            </button>
          </span>

          <div className="flex flex-col ml-4">
            <img
              alt="paypal credit"
              src="./assets/images/pay-pal-credit.png"
              className="w-[120px] md:w-[170px] m-auto bg-white px-5 md:px-7 py-2 rounded-[2.5rem]"
            />
          </div>
        </div>

        <div className="w-full flex justify-between mt-10 mb-7 flex-row items-center">
          <NavLink key="b3 bands" to="/bundle">
            <Button className="uppercase text-xs md:text-base px-4 py-1 rounded-full font-light w-auto">
              <div className="inline-block pr-1 relative top-[3px]">
                <ArrowLeftIcon
                  fill="white"
                  className="h-[0.9rem] md:h-[1.1rem] w-[1.1rem]"
                  aria-hidden="true"
                  color="white"
                />
              </div>
              {"Back"}
            </Button>
          </NavLink>
          <NavLink
            key="nutrition products"
            to="/nutrition-products"
            ref={nextButtonRef}
          >
            <Button className="uppercase text-xs md:text-base px-4 py-1 rounded-full font-light w-auto">
              Next
              <div className="inline-block pl-1 relative top-[3px]">
                <ArrowRightIcon
                  fill="white"
                  className="h-[0.9rem] md:h-[1.1rem] w-[1.1rem]"
                  aria-hidden="true"
                  color="white"
                />
              </div>
            </Button>
          </NavLink>
        </div>
      </section>
      <Transition appear show={paypalModalOpen} as={Fragment}>
        <Dialog
          as="div"
          className="relative z-50"
          onClose={() => setPaypalModalOpen(false)}
        >
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0"
            enterTo="opacity-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100"
            leaveTo="opacity-0"
          >
            <div className="fixed inset-0 bg-black bg-opacity-50" />
          </Transition.Child>

          <div className="fixed inset-0 overflow-y-auto">
            <div className="flex min-h-full items-center justify-center p-4 text-center">
              <Transition.Child
                as={Fragment}
                enter="ease-out duration-300"
                enterFrom="opacity-0 scale-95"
                enterTo="opacity-100 scale-100"
                leave="ease-in duration-200"
                leaveFrom="opacity-100 scale-100"
                leaveTo="opacity-0 scale-95"
              >
                <Dialog.Panel className="w-full max-w-2xl px-8 transform overflow-hidden rounded-2xl bg-white p-6 text-left align-middle shadow-xl transition-all">
                  <div className="flex justify-between items-center mb-4">
                    <div className="flex items-center space-x-2 mt-1">
                      <img
                        src="./assets/images/paypal-s.png"
                        alt="PayPal Logo"
                        className="w-6 h-6"
                      />
                      <h3 className="text-lg font-semibold">PayPal Credit</h3>
                    </div>
                    <button
                      onClick={() => setPaypalModalOpen(false)}
                      className="text-gray-700 text-2xl"
                    >
                      &times;
                    </button>
                  </div>

                  <div className="space-y-4">
                    <p className="text-2xl md:text-4xl font-bold text-gray-900">
                      If Qualified, Pay nothing today and get No Interest if paid
                      in full in 6 months on purchases of $149 or more when you
                      check out with PayPal Credit.
                    </p>
                    <p className="text-lg text-gray-700">
                      Interest will be charged to your account from the purchase
                      date if the balance is not paid in full within the
                      promotional period. Minimum monthly payments required.
                    </p>
                  </div>
                </Dialog.Panel>
              </Transition.Child>
            </div>
          </div>
        </Dialog>
      </Transition>
    </>
  );
}
